import { memo, type NamedExoticComponent, type PropsWithChildren } from "react";
import { useReadableTimeWindow } from "src/hooks/useReadableTimeWindow";

type CardSubtitleProps = PropsWithChildren;
const CardSubtitle = ({ children }: CardSubtitleProps) => (
  <div className="typo-subtitle">{children}</div>
);

// Card subtitle variant with auto-included time-window text
const TimeWindow = () => <CardSubtitle>{useReadableTimeWindow()}</CardSubtitle>;

const MemoedCardSubtitle = memo(
  CardSubtitle
) as unknown as NamedExoticComponent<CardSubtitleProps> & {
  TimeWindow: typeof TimeWindow;
};

MemoedCardSubtitle.displayName = "CardSubtitle";
MemoedCardSubtitle.TimeWindow = TimeWindow;

export default MemoedCardSubtitle;
